<script setup>
const props = defineProps({
  mobileWidth: Number,
  dailyCustomObject: Object,
  dailyFortuneDetail: Object,
});

const isMobileView = ref(false);

onMounted(() => {
  if (window.innerWidth <= props.mobileWidth) {
    isMobileView.value = true;
  }
});
</script>

<template>
  <div class="df-card white">
    <div class="df-card br-8 df-preview ilgin">
      <div class="df-preview__text-section">
        <div class="df-preview__title">
          {{ dailyFortuneDetail?.일일운세?.일운?.기준점수?.이모지제목 || '' }}
        </div>
        <div class="df-preview__subtitle">
          {{ dailyFortuneDetail?.일일운세?.일운?.기준점수?.이모지설명 || '' }}<br>
          {{ dailyFortuneDetail?.일일운세?.일운?.기준점수?.이모지내용 || '' }}
        </div>
      </div>
      <div v-if="!isMobileView" class="df-preview__icon-section energy energy-xl" :class="`energy${dailyCustomObject['점수']}`">
        <div class="energy-rate">{{`${dailyCustomObject['확률']} %`}}</div>
        <i></i>
      </div>
      <div
        v-else
        class="df-preview__icon-section energy energy-xl"
        :class="`energy${dailyCustomObject['점수']}`"
        style="flex-direction: row; gap: 8px"
      >
        <i></i>
        <div class="energy-rate" style="width: fit-content;">
          {{`${dailyCustomObject['확률']} %`}}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.df-preview.ilgin{
  padding: 20px 40px;
}
</style>